import { render, staticRenderFns } from "./newAfterCheck.vue?vue&type=template&id=7bb7bd3b&"
import script from "./newAfterCheck.vue?vue&type=script&lang=js&"
export * from "./newAfterCheck.vue?vue&type=script&lang=js&"
import style0 from "./newAfterCheck.vue?vue&type=style&index=0&id=7bb7bd3b&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bb7bd3b')) {
      api.createRecord('7bb7bd3b', component.options)
    } else {
      api.reload('7bb7bd3b', component.options)
    }
    module.hot.accept("./newAfterCheck.vue?vue&type=template&id=7bb7bd3b&", function () {
      api.rerender('7bb7bd3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/newAfterCheck.vue"
export default component.exports